<template>
  <el-form
      ref="form"
      :model="form"
      :rules="rules"
      :label-position="labelPosition"
      label-width="120px"
  >
    <el-form-item
        label="机器人名称"
        prop="appName"
    >
      <el-input
          placeholder="请输入"
          v-model="form.appName"
      ></el-input>
    </el-form-item>
    <el-form-item
        label="描述"
        prop="appDesc"
    >
      <el-input
          placeholder="请输入"
          v-model="form.appDesc"
      ></el-input>
    </el-form-item>
    <el-form-item
        label="APP ID"
        prop="appId"
    >
      <el-input
          placeholder="请输入"
          v-model="form.appId"
      ></el-input>
    </el-form-item>
    <el-form-item
      label="APP 密钥"
      prop="appSecret"
    >
      <el-input
          v-model="form.appSecret"
      ></el-input>
    </el-form-item>
    <el-form-item
        key="eventReceiveMode"
        label="事件接收方式"
        prop="eventReceiveMode"
    >
      <el-radio-group v-model="form.eventReceiveMode" @change="receiveModeChange">
        <el-radio label="webhook">Webhook回调</el-radio>
        <el-radio label="long_connection">长连接</el-radio>
      </el-radio-group>
      <div v-if="form.eventReceiveMode === 'long_connection'" class="form-tip">启用后由服务建立长连接，无需公网回调地址。Lark后台也需选择“使用长连接接收事件”。</div>
    </el-form-item>
    <el-form-item
        v-if="form.eventReceiveMode === 'webhook'"
        key="eventEncryptKey"
        label="事件加密密钥"
        prop="eventEncryptKey"
    >
      <el-input
          v-model="form.eventEncryptKey"
      ></el-input>
    </el-form-item>
    <el-form-item
        v-if="form.eventReceiveMode === 'webhook'"
        key="eventVerificationToken"
        label="事件验签token"
        prop="eventVerificationToken"
    >
      <el-input
          v-model="form.eventVerificationToken"
      ></el-input>
    </el-form-item>
    <el-form-item
        key="appRole"
        label="功能定位"
        prop="appRole"
    >
      <el-checkbox
          v-model="collectChecked"
      >采集</el-checkbox>
      <el-checkbox
          v-model="pushChecked"
      >推送</el-checkbox>
    </el-form-item>
      <el-form-item
          key="status"
          label="状态"
          prop="status"
      >
          <el-radio
              v-model="form.status"
              :label="1"
          >启用</el-radio>
          <el-radio
              v-model="form.status"
              :label="0"
          >禁用</el-radio>
      </el-form-item>
  </el-form>
</template>

<script>
import formLabalPosition from "@/mixins/formLabalPosition";
let originForm = {
  appName: '',
  appDesc: '',
  appId: '',
  appSecret: '',
  eventReceiveMode: 'webhook',
  eventEncryptKey: '',
  eventVerificationToken: '',
  status: 1,
  appRole: 2,
}
export default {
  name: "wechatForm",
  components:{
  },
  props: {
    formData:{
      type: Object,
      default(){
        return {
          ...originForm,
        }
      }
    },
  },

  data() {
    return {
      form: {
        ...originForm,
      },
      rules:{
        appName: [
          { required: true, message: '请输入', trigger: 'blur' },
        ],
        appDesc:[
          { required: true, message: '请输入', trigger: 'blur' },
        ],
        appId:[
          { required: true, message: '请输入', trigger: 'blur' },
        ],
        appSecret:[
          { required: true, message: '请输入', trigger: 'blur' },
        ],
        eventEncryptKey:[
          { validator: this.validateWebhookCredential, trigger: 'blur' },
        ],
        eventVerificationToken:[
          { validator: this.validateWebhookCredential, trigger: 'blur' },
        ],
        appRole:[
          { validator: this.validateAppRole, trigger: 'change' },
        ],
      },
    }
  },
  computed: {
    collectChecked: {
      get() { return (this.form.appRole & 1) === 1 },
      set(val) {
        // 位掩码：清除采集位后按勾选状态置位
        this.form.appRole = ((this.form.appRole || 0) & ~1) | (val ? 1 : 0);
      },
    },
    pushChecked: {
      get() { return (this.form.appRole & 2) === 2 },
      set(val) {
        this.form.appRole = ((this.form.appRole || 0) & ~2) | (val ? 2 : 0);
      },
    },
  },
  mixins: [formLabalPosition],
  watch:{
    formData:{
      handler(newVal,oldVal){
        if(newVal){
            this.assign();
        }
      },
      deep:true,
    },
  },
  created(){
      this.assign();
  },
  methods:{
    receiveModeChange(){
      this.$nextTick(() => this.$refs.form.clearValidate(['eventEncryptKey', 'eventVerificationToken']));
    },
    validateWebhookCredential(rule, value, callback){
      if(this.form.eventReceiveMode === 'webhook' && !String(value || '').trim()){
        callback(new Error('Webhook模式下必须填写'));
      }else{
        callback();
      }
    },
    // required 不会拦截 0，故用 validator 显式校验身份合法（1/2/3）
    validateAppRole(rule, value, callback){
      if(value === 1 || value === 2 || value === 3){
        callback();
      }else{
        callback(new Error('请选择应用身份'));
      }
    },
      assign(){
          // 合并默认值：存量数据缺 appRole 时按后端约定回落为 2（仅推送）
          this.form = {
              ...originForm,
              ...this.formData,
          }
          if(this.form.appRole == null) this.form.appRole = 2;
          if(this.form.eventReceiveMode == null) this.form.eventReceiveMode = 'webhook';
      },
    reset(){
      this.form = {
        ...originForm,
      };
    },
    validate(){
      this.$refs.form.validate((valid) => {
        if(valid){
          this.$emit('submit',this.form);
        }
      })
    },
  },
}
</script>

<style scoped>

</style>
